"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchMBOMKey = void 0;
const index_1 = __importDefault(require("../utils/request/index"));
//查询节点信息
const searchMBOMKey = (sn, keywords) => {
    return (0, index_1.default)("/mbom/keywords", {
        method: "GET",
        params: {
            sn,
            keywords,
        },
    });
};
exports.searchMBOMKey = searchMBOMKey;
